<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Room
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="form.seat_count"
                outlined
                label="Total Seats"
                prepend-inner-icon="mdi-seat"
                :items="seatOptions"
                @change="fetchSeatConfigurations"
              ></v-select>
            </v-col>

            <v-col sm="4">
              <v-select
                v-model="form.seat_config_id"
                outlined
                label="Seat Configuration"
                prepend-inner-icon="mdi-crown"
                :items="availableConfigurations"
                item-text="name"
                item-value="id"
                :disabled="!form.seat_count || configurationsLoading"
                :loading="configurationsLoading"
                clearable
                hint="Select VIP seat layout (optional)"
                persistent-hint
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-chip x-small class="mr-1" color="amber" text-color="white" v-if="item.vip_seats > 0">
                        <v-icon left x-small>mdi-crown</v-icon>
                        {{ item.vip_seats }} VIP
                      </v-chip>
                      <span v-if="item.vip_seat_positions && item.vip_seat_positions.length">
                        Positions: {{ item.vip_seat_positions.join(', ') }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>

            <v-col sm="4">
              <label for="profileFile" class="block font-medium mb-2"
                >Profile Image:</label
              >
              <br />
              <input
                type="file"
                id="profileFile"
                name="profileFile"
                :ref="'profileFile'"
                @change="onFileChange($event, 'profile')"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="resetImage('profile')"
                >Remove</v-btn
              >

              <div v-if="profile_path" class="mt-5">
                <label>Image Preview</label><br />
                <img
                  :src="profile_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
            <!-- <v-col sm="4">
              <label for="backgroundFile" class="block font-medium mb-2"
                >Background Image:</label
              >
              <br />
              <input
                type="file"
                id="backgroundFile"
                name="backgroundFile"
                :ref="'backgroundFile'"
                @change="onFileChange($event, 'background')"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="resetImage('background')"
                >Remove</v-btn
              >

              <div v-if="background_path" class="mt-5">
                <label>Image Preview</label><br />
                <img
                  :src="background_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col> -->
            <v-col sm="4" v-if="form.is_private">
              <v-text-field
                v-model="form.password"
                outlined
                label="Enter Room Password"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_private"
                inset
                :label="`Is Private: ${form.is_private ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Room
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "RoomCreatePage",
  data() {
    return {
      form: {
        role_id: 3,
        name: "",
        seat_count: null,
        seat_config_id: null,
      },
      isLoading: false,
      configurationsLoading: false,
      background_path: "",
      profile_path: "",
      seatOptions: [
        // { text: "8 Seats", value: 8 },
        { text: "10 Seats", value: 10 },
        { text: "15 Seats", value: 15 },
        { text: "20 Seats", value: 20 },
      ],
      availableConfigurations: [],
    };
  },
  methods: {
    async fetchSeatConfigurations() {
      if (!this.form.seat_count) {
        this.availableConfigurations = [];
        this.form.seat_config_id = null;
        return;
      }

      this.configurationsLoading = true;
      try {
        const response = await axios.get(
          `/seats/by-total/${this.form.seat_count}`
        );

        if (response.data.success) {
          this.availableConfigurations = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching seat configurations:", error);
        this.$toasted.error("Failed to load seat configurations");
      } finally {
        this.configurationsLoading = false;
      }
    },
    async save() {
      try {
        this.isLoading = true;

        const formData = new FormData();
        // Append form fields
        for (const key in this.form) {
          formData.append(key, this.form[key]);
        }
        // Append profile and background images (as files)
        const profileFile = this.$refs.profileFile?.files[0];
        const backgroundFile = this.$refs.backgroundFile?.files[0];
        if (profileFile) {
          formData.append("profile_path", profileFile);
        }
        if (backgroundFile) {
          formData.append("background_path", backgroundFile);
        }

        console.log("formData", formData);

        await axios.post("/rooms", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/rooms");
      } catch (e) {
        console.error("Save error:", e);
        this.isLoading = false;
      }
    },

    onFileChange(event, type) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (evt) => {
        if (type === "profile") {
          this.profile_path = evt.target.result;
        } else if (type === "background") {
          this.background_path = evt.target.result;
        }
      };

      reader.onerror = (evt) => {
        console.error("File reading error", evt);
      };

      reader.readAsDataURL(file);
    },

    resetImage(type) {
      if (type === "profile") {
        this.$refs.profileFile.value = null;
        this.profile_path = null;
      } else if (type === "background") {
        this.$refs.backgroundFile.value = null;
        this.background_path = null;
      }
    },
  },
};
</script>
